/* eslint-disable no-mixed-operators */
import React from 'react';
import "./style.css";
import Logo from "../img/Logo.png";
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { NavDropdown } from 'react-bootstrap';
import { useNavigate, Link, useLocation } from "react-router-dom";
import Swal from 'sweetalert2'
import jwt from "jsonwebtoken";
import { checkGroupsUser, getlocalStorage } from '../function/functionALL';
import { FaUndoAlt } from "react-icons/fa";
import Axios from "axios";
const TopBar = () => {

  const navigate = useNavigate()
  const location = useLocation()
  const { Token, DataToken_ } = getlocalStorage();
  const role = checkGroupsUser(DataToken_.groups);
  const role_name = role?.role_name;
  const role_openRole = role?.openRole;

  const refreshAccess = async (silent = true) => {
    try {
      const response = await Axios.get(process.env.REACT_APP_API_USERS + `${DataToken_.id}/`,
        {
          headers: {
            Authorization: "Token " + Token,
          },
        });
      if (response.statusText === "OK" || response.status === 200) {
        const rights = await JSON.parse(JSON.stringify(response.data));
        const {
          test_results_list,
          ...result
        } = rights;
        const encodedToken = jwt.sign(result, process.env.REACT_APP_JWT, {
          expiresIn: "1d",
        });

        localStorage.setItem('Token_', encodedToken);

        if (!silent) {
          if (Token !== encodedToken) {
            Swal.fire({
              title: 'ปรับปรุงข้อมูลสำเร็จ!',
              icon: 'success',
              confirmButtonText: 'ปิด'
            }).then((result) => {
              if (result.isConfirmed) {
                navigate('/PageHome');
                navigate(0);
              }
            });
          } else {
            Swal.fire({
              title: 'ปรับปรุงข้อมูลสำเร็จ!',
              icon: 'success',
              confirmButtonText: 'ปิด'
            }).then((result) => {
              if (result.isConfirmed) {
                navigate(0);
              }
            });
          }
        }
      } else {
        console.error('Failed to fetch access rights');
      }
    } catch (error) {
      console.error('Error fetching access rights:', error);
    }
  };

  const handleReload = async () => {
    await refreshAccess(false);
  };

  React.useEffect(() => {
    // Auto-refresh silently on every page open/change
    refreshAccess(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);


  function logout() {

    localStorage.removeItem("Token_");
    localStorage.removeItem("Token");

    Swal.fire({
      position: 'top-end',
      title: '<div style="display:flex; justify-content: center; text-align: center; width:100%; margin:-20px 0 0 0;"><i class="fas fa-check-circle" style="font-size:24px;color:#7cb342"></i><h5 style="font-size: 20px; margin: 0 0 0 2%;color:#7cb342;">ออกสู่ระบบสำเร็จ</h5></div>',
      customClass: {
        title: 'my-swal-title',
        content: 'my-swal-text',
        closeButton: 'my-swal-close',
        popup: 'my-swal-popup',
        icon: 'my-swal-icon'
      },
      showCloseButton: true,
      showConfirmButton: false,
      timer: 2500
    })
    navigate("/PageLogin");
  };

  return (
    <>
      <style>
        {`
        .my-swal-close {
          font-size: 24px;
        }
        .my-swal-popup {
          padding: 0;
          width: 480px;
          height: 90px;             
        }
       
      `}
      </style>
      <Navbar collapseOnSelect expand="md" variant="light" style={{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: 99, backgroundColor: "rgb(247, 247, 247, 0.99)", borderBottom: "8px ridge  rgba(217, 195, 253, 0.6)" }} className="mb-5">
      

          <Container fluid >
            <Navbar.Brand className="col-2 col-md-4 col-lg-4 col-xl-6 col-xxl-8  ">
              <div className="logo d-flex w-100 align-items-center  ">
                <Link to="/PageHome">
                  <img
                    src={Logo}
                    className="logo-upscale p-auto mx-4 w-auto m-0 figure-img img-fluid rounded"
                    alt="logo"
                    width="100px"
                    height="100px"
                  />
                </Link>
                <div className="pt-0 d-none d-xxl-block">
                  <span style={{ color: "#000000", fontSize: "25px" }}><b>ระบบทดสอบสมรรถภาพทางกายกำลังพล ทหารอากาศ</b></span>
                  <div className="pt-2" style={{ color: "#767676", fontSize: "18px" }}>
                    <b>
                      <span className="pt-2 text-decoration-underline" style={{ color: "#767676", fontSize: "18px", fontFamily: 'Noto Sans Thai' }}>บัญชีผู้ใช้</span> : <span className="ms-1" style={{ color: "#767676", fontSize: "18px", fontFamily: 'Noto Sans Thai' }} >{DataToken_.full_name} </span>
                      <span className="pt-2 ms-1 text-decoration-underline" style={{ color: "#767676", fontSize: "18px", fontFamily: 'Noto Sans Thai' }}>สิทธิ์ผู้ใช้งานระบบ</span>  :
                      {' '}{role_name}
                    </b>
                  </div>
                </div>
                <div className="d-flex col-2 ms-1 px-3" onClick={handleReload}>

                  <button type="button"
                    className="btn btn-outline-warning d-none d-md-block"
                    style={{
                      // border: "none",
                      width: "122px",
                    }} > <FaUndoAlt />{" "}Refresh
                  </button>

                </div>
              </div>
            </Navbar.Brand>
            <div className="d-flex align-items-center ">
              <button
                type="button"
                className="btn btn-outline-warning d-md-none me-4" onClick={handleReload}
              >
                <FaUndoAlt />
              </button>
              <Navbar.Toggle aria-controls="responsive-navbar-nav" />
            </div>

            <Navbar.Collapse id="responsive-navbar-nav" className="col-10 col-md-6 col-lg-5 col-xl-4 col-xxl-3 ">
              <Nav className="w-100 ">
                {/* {role_openRole?.UnitAdmin || role_openRole?.RTAFPersonAdmin ? */}

                  <Nav.Link className="rounded  " as={Link} to="/PageResultGraph" style={{ width: "50%" }}>
                    <div style={{ fontWeight: 'bold', fontSize: "19px" }}>Dashboard</div>
                  </Nav.Link> 
                  {/* : null} */}
                <hr />
                <Nav.Link as={Link} to="/PageHome" style={{ width: "40%" }}>
                  <div style={{ fontWeight: 'bold', fontSize: "19px" }}>หน้าหลัก</div>
                </Nav.Link>
                <hr />
                {role_openRole?.UnitAdmin || role_openRole?.RTAFPersonAdmin ?
                  <NavDropdown title="การจัดการ" id="collasible-nav-dropdown" style={{ width: "40%", fontWeight: 'bold', fontSize: "19px" }}>
                  <NavDropdown.Item  as={Link} to="https://docs.google.com/forms/d/e/1FAIpQLScb9Fwy4G0rdExx7-DhnfUkFSK_JtOU5AZVLZWnn-8FHySYWw/viewform" style={{ fontWeight: 'bold', fontSize: '16px' ,backgroundColor:"#ffc107"}}>แบบสอบถามความพึงพอใจ 🔔 </NavDropdown.Item>

                    <NavDropdown.Item as={Link} to="/PageManageUser" style={{ fontWeight: 'bold', fontSize: "16px" }}>ข้อมูลกำลังพลภายในหน่วย</NavDropdown.Item>
                    {/* <NavDropdown.Item href="/PageManageQuestion" style={{ fontWeight: 'bold', fontSize: "16px" }}>จัดการคำถามประเมินการทดสอบ</NavDropdown.Item> */}
                    <NavDropdown.Item as={Link} to="https://api-pft.rtaf.mi.th/" style={{ fontWeight: 'bold', fontSize: '16px' }}>เพิ่มข้อมูลผู้ทดสอบ</NavDropdown.Item>

                    <NavDropdown.Item as={Link} to="/PageEditInformation" style={{ fontWeight: 'bold', fontSize: '16px', color: '#666699' }}>ข้อมูลส่วนตัว</NavDropdown.Item>
                  </NavDropdown>
                   : role_openRole?.FunctionaryTester ?
                   <NavDropdown title="การจัดการ" id="collasible-nav-dropdown" style={{ width: "50%", fontWeight: 'bold', fontSize: "19px" }}>
                    <NavDropdown.Item  as={Link} to="https://docs.google.com/forms/d/e/1FAIpQLScb9Fwy4G0rdExx7-DhnfUkFSK_JtOU5AZVLZWnn-8FHySYWw/viewform" style={{ fontWeight: 'bold', fontSize: '16px' ,backgroundColor:"#ffc107"}}>แบบสอบถามความพึงพอใจ 🔔 </NavDropdown.Item>
                    <NavDropdown.Item as={Link} to="/PageEditInformation" style={{ fontWeight: 'bold', fontSize: '16px', color: '#666699' }}>ข้อมูลส่วนตัว</NavDropdown.Item>
                  </NavDropdown>
                  :
                  <NavDropdown title="การจัดการ" id="collasible-nav-dropdown" style={{ width: "50%", fontWeight: 'bold', fontSize: "19px" }}>
                  <NavDropdown.Item as={Link} to="/PageEditInformation" style={{ fontWeight: 'bold', fontSize: '16px', color: '#666699' }}>ข้อมูลส่วนตัว</NavDropdown.Item>
                </NavDropdown>
                  }
                <hr />
                <Nav.Link style={{ width: "50%" }}>
                  <div style={{ fontWeight: 'bold', fontSize: "19px" }} onClick={logout}>ออกจากระบบ</div>
                </Nav.Link>
              </Nav>
            </Navbar.Collapse>
          </Container>
          {/* : */}




      </Navbar>

    </>
  )
}

export default TopBar
// {role_openRole?.UnitAdmin || role_openRole?.RTAFPersonAdmin ?

//   <Container fluid >
//     <Navbar.Brand className="col-2 col-md-4 col-lg-4 col-xl-6 col-xxl-8  ">
//       <div className="logo d-flex w-100 align-items-center  ">
//         <Link to="/PageHome">
//           <img
//             src={Logo}
//             className="logo-upscale p-auto mx-4 w-auto m-0 figure-img img-fluid rounded"
//             alt="logo"
//             width="100px"
//             height="100px"
//           />
//         </Link>
//         <div className="pt-0 d-none d-xxl-block">
//           <span style={{ color: "#000000", fontSize: "25px" }}><b>ระบบทดสอบสมรรถภาพทางกายกำลังพล ทหารอากาศ</b></span>
//           <div className="pt-2" style={{ color: "#767676", fontSize: "18px" }}>
//             <b>
//               <span className="pt-2 text-decoration-underline" style={{ color: "#767676", fontSize: "18px", fontFamily: 'Noto Sans Thai' }}>บัญชีผู้ใช้</span> : <span className="ms-1" style={{ color: "#767676", fontSize: "18px", fontFamily: 'Noto Sans Thai' }} >{DataToken_.full_name} </span>
//               <span className="pt-2 ms-1 text-decoration-underline" style={{ color: "#767676", fontSize: "18px", fontFamily: 'Noto Sans Thai' }}>สิทธิ์ผู้ใช้งานระบบ</span>  :
//               {' '}{role_name}
//             </b>
//           </div>
//         </div>
//         <div className="d-flex col-2 ms-1 px-3" onClick={handleReload}>

//           <button type="button"
//             className="btn btn-outline-warning d-none d-md-block"
//             style={{
//               // border: "none",
//               width: "122px",
//             }} > <FaUndoAlt />{" "}Refresh
//           </button>

//         </div>
//       </div>
//     </Navbar.Brand>
//     <div className="d-flex align-items-center ">
//       <button
//         type="button"
//         className="btn btn-outline-warning d-md-none me-4" onClick={handleReload}
//       >
//         <FaUndoAlt />
//       </button>
//       <Navbar.Toggle aria-controls="responsive-navbar-nav" />
//     </div>

//     <Navbar.Collapse id="responsive-navbar-nav" className="col-10 col-md-6 col-lg-5 col-xl-4 col-xxl-3 ">
//       <Nav className="w-100 ">
//         {role_openRole?.UnitAdmin || role_openRole?.RTAFPersonAdmin ?

//           <Nav.Link className="rounded  " as={Link} to="/PageResultGraph" style={{ width: "40%" }}>
//             <div style={{ fontWeight: 'bold', fontSize: "19px" }}>Dashboard</div>
//           </Nav.Link> : null}
//         <hr />
//         <Nav.Link as={Link} to="/PageHome" style={{ width: "30%" }}>
//           <div style={{ fontWeight: 'bold', fontSize: "19px" }}>หน้าหลัก</div>
//         </Nav.Link>
//         <hr />
//         {role_openRole?.UnitAdmin || role_openRole?.RTAFPersonAdmin ?
//           <NavDropdown title="การจัดการ" id="collasible-nav-dropdown" style={{ width: "40%", fontWeight: 'bold', fontSize: "19px" }}>
//             <NavDropdown.Item as={Link} to="/PageManageUser" style={{ fontWeight: 'bold', fontSize: "16px" }}>ข้อมูลกำลังพลภายในหน่วย</NavDropdown.Item>
//             {/* <NavDropdown.Item href="/PageManageQuestion" style={{ fontWeight: 'bold', fontSize: "16px" }}>จัดการคำถามประเมินการทดสอบ</NavDropdown.Item> */}
//             <NavDropdown.Item as={Link} to="https://api-pft.rtaf.mi.th/" style={{ fontWeight: 'bold', fontSize: '16px' }}>เพิ่มข้อมูลผู้ทดสอบ</NavDropdown.Item>

//             <NavDropdown.Item as={Link} to="/PageEditInformation" style={{ fontWeight: 'bold', fontSize: '16px', color: '#666699' }}>ข้อมูลส่วนตัว</NavDropdown.Item>
//           </NavDropdown>
//           : <NavDropdown title="การจัดการ" id="collasible-nav-dropdown" style={{ width: "60%", fontWeight: 'bold', fontSize: "19px" }}>
//             <NavDropdown.Item as={Link} to="/PageEditInformation" style={{ fontWeight: 'bold', fontSize: '16px', color: '#666699' }}>ข้อมูลส่วนตัว</NavDropdown.Item>
//           </NavDropdown>}
//         <hr />
//         <Nav.Link style={{ width: "40%" }}>
//           <div style={{ fontWeight: 'bold', fontSize: "19px" }} onClick={logout}>ออกจากระบบ</div>
//         </Nav.Link>
//       </Nav>
//     </Navbar.Collapse>
//   </Container>
//   :

//   <Container fluid >
//     <Navbar.Brand className="col-2 col-md-6 col-lg-7 col-xl-8 col-xxl-9">
//       <div className="logo d-flex w-100 align-items-center">
//         <Link to="/PageHome">
//           <img
//             src={Logo}
//             className="logo-upscale p-auto mx-4 w-auto m-0 figure-img img-fluid rounded"
//             alt="logo"
//             width="100px"
//             height="100px"
//           />
//         </Link>
//         <div className="pt-0 d-none d-xxl-block">
//           <span style={{ color: "#000000", fontSize: "25px" }}><b>ระบบทดสอบสมรรถภาพทางกายกำลังพล ทหารอากาศ</b></span>
//           <div className="pt-2" style={{ color: "#767676", fontSize: "18px" }}>
//             <b>
//               <span className="pt-2 text-decoration-underline" style={{ color: "#767676", fontSize: "18px", fontFamily: 'Noto Sans Thai' }}>บัญชีผู้ใช้</span> : <span className="ms-1" style={{ color: "#767676", fontSize: "18px", fontFamily: 'Noto Sans Thai' }} >{DataToken_.full_name} </span>
//               <span className="pt-2 ms-1 text-decoration-underline" style={{ color: "#767676", fontSize: "18px", fontFamily: 'Noto Sans Thai' }}>สิทธิ์ผู้ใช้งานระบบ</span>  :
//               {' '}{role_name}
//             </b>
//           </div>
//         </div>
//         <div className="d-flex col-2 ms-1 px-3" onClick={handleReload}>

//           <button type="button"
//             className="btn btn-outline-warning d-none d-md-block"
//             style={{

//               width: "122px",
//             }} > <FaUndoAlt />{" "}Refresh
//           </button>

//         </div>
//       </div>
//     </Navbar.Brand>
//     <div className="d-flex align-items-center ">
//       <button
//         type="button"
//         className="btn btn-outline-warning d-md-none me-4" onClick={handleReload}
//       >
//         <FaUndoAlt />
//       </button>
//       <Navbar.Toggle aria-controls="responsive-navbar-nav" />
//     </div>

//     <Navbar.Collapse id="responsive-navbar-nav" className="col-10 col-md-6 col-lg-5 col-xl-4 col-xxl-3">
//       <Nav className="w-100">
//         <Nav.Link as={Link} to="/PageHome" style={{ width: "50%" }}>
//           <div style={{ fontWeight: 'bold', fontSize: "19px" }}>หน้าหลัก</div>
//         </Nav.Link>
//         <hr />
//         {role_openRole?.UnitAdmin || role_openRole?.RTAFPersonAdmin ?
//           <NavDropdown title="การจัดการ" id="collasible-nav-dropdown" style={{ width: "60%", fontWeight: 'bold', fontSize: "19px" }}>
//             <NavDropdown.Item as={Link} to="/PageManageUser" style={{ fontWeight: 'bold', fontSize: "16px" }}>ข้อมูลกำลังพลภายในหน่วย</NavDropdown.Item>
//             {/* <NavDropdown.Item href="/PageManageQuestion" style={{ fontWeight: 'bold', fontSize: "16px" }}>จัดการคำถามประเมินการทดสอบ</NavDropdown.Item> */}
//             <NavDropdown.Item as={Link} to="https://api-pft.rtaf.mi.th/" style={{ fontWeight: 'bold', fontSize: '16px' }}>เพิ่มข้อมูลผู้ทดสอบ</NavDropdown.Item>

//             <NavDropdown.Item as={Link} to="/PageEditInformation" style={{ fontWeight: 'bold', fontSize: '16px', color: '#666699' }}>ข้อมูลส่วนตัว</NavDropdown.Item>
//           </NavDropdown>
//           : <NavDropdown title="การจัดการ" id="collasible-nav-dropdown" style={{ width: "60%", fontWeight: 'bold', fontSize: "19px" }}>
//             <NavDropdown.Item as={Link} to="/PageEditInformation" style={{ fontWeight: 'bold', fontSize: '16px', color: '#666699' }}>ข้อมูลส่วนตัว</NavDropdown.Item>
//           </NavDropdown>}
//         <hr />
//         <Nav.Link style={{ width: "60%" }}>
//           <div style={{ fontWeight: 'bold', fontSize: "19px" }} onClick={logout}>ออกจากระบบ</div>
//         </Nav.Link>
//       </Nav>
//     </Navbar.Collapse>
//   </Container>
// }